<template>
  <div
    :class="[
      'grade-filter',
      gradeFilterToApply?.colour,
      gradeFilterToApply?.inactive,
    ]"
    @click="selectFilter(gradeFilterToApply?.grade)"
  >
    <img
      class="music-img-bkg-normal"
      src="../assets/icon_music.jpg"
      width="50"
      height="50"
      :alt="`List all ${gradeFilterToApply?.grade} dances.`"
    />
    <img
      class="music-img-bkg-small"
      src="../assets/icon_music.jpg"
      width="25"
      height="25"
      :alt="`List all ${gradeFilterToApply?.grade} dances.`"
    />
    <!-- <div v-if="isThisAFeis === 'true'"> -->
      <p id="grade-filter-text" v-if="gradeFilterToApply?.grade === 'Beginner'">{{`${bunLabel}`}}</p>
      <p id="grade-filter-text" v-if="gradeFilterToApply?.grade === 'Primary'">{{`${tusLabel}`}}</p>
      <p id="grade-filter-text" v-if="gradeFilterToApply?.grade === 'Intermediate'">{{`${meanLabel}`}}</p>
      <p id="grade-filter-text" v-if="gradeFilterToApply?.grade === 'Open'">{{`${openLabel}`}}</p>
      <p id="grade-filter-text" v-if="gradeFilterToApply?.grade !== 'Beginner' && gradeFilterToApply?.grade !== 'Primary' && gradeFilterToApply?.grade !== 'Intermediate' && gradeFilterToApply?.grade !== 'Open'">{{ gradeFilterToApply?.grade }}</p>
    <!-- </div>
    <div v-if="isThisAFeis === 'false'">
      <p id="grade-filter-text">{{ gradeFilterToApply?.grade }}</p>
    </div>     -->
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line no-unused-vars
import { IRegionFilters } from "@/interfaces/region_filters";
// eslint-disable-next-line no-unused-vars
import GradeFilter from "../model/grade_filter";
// eslint-disable-next-line no-unused-vars
import { defineComponent, watch, ref, PropType, onBeforeMount, inject } from "vue";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "@/interfaces/configuration_service";

export default defineComponent({
  props: {
    gradeFilter: Object as PropType<GradeFilter>,
    activeFilter: String
  },
  emits: ["filter-clicked"],
  setup(props, { emit }) {
    const configurationService = inject<IConfigurationService>("configurationService");
    const currentlyActiveFilter = ref(props.activeFilter);
    const selectedRegion = configurationService?.getSelectedRegion();
    const gradeFilterToApply = ref(props.gradeFilter);
    const isThisAFeis= ref<string>("false");
    const isThisAClass= ref<string>("false");
    const bunLabel = ref<string>("Bun Grad");
    const tusLabel = ref<string>("Tus Grad");
    const meanLabel = ref<string>("Mean Grad");
    const openLabel = ref<string>("Open");

    if (gradeFilterToApply?.value) {
      watch(gradeFilterToApply, applyInactiveFilter);
    }
    if (currentlyActiveFilter?.value) {
      watch(currentlyActiveFilter, applyInactiveFilter);
    }

    function selectFilter(filterName: string) {
      emit("filter-clicked", filterName);
      currentlyActiveFilter.value = filterName;
    }

    function applyInactiveFilter() {
      return gradeFilterToApply?.value?.grade !== currentlyActiveFilter?.value
        ? "inactive"
        : "active";
    }

    function getFeisStatusAndLabels()
    {
      //const propIsAtFeis = selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
      // const propIsAtClass = selectedRegion?.map((item: IRegionFilters) => item?.isClass);
      // if (propIsAtFeis)
      // {
        isThisAFeis.value = selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
        isThisAClass.value = selectedRegion?.map((item: IRegionFilters) => item?.isClass);
        bunLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.bunTitle);
        tusLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.tusTitle);
        meanLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.meanTitle);
        openLabel.value = selectedRegion?.map((item: IRegionFilters) => item?.openTitle);
        // if (propIsAtFeis?.length > 0)
        // {
        //   isThisAFeis.value = propIsAtFeis[0];
        //   console.log(`BUN LABEL: ${bunLabel.value}`)
        //   console.log(`TUS LABEL: ${tusLabel.value}`)
        //   console.log(`MEAN LABEL: ${meanLabel.value}`)
        //   console.log(`OPEN LABEL: ${openLabel.value}`)
        //   console.log(`isThisAFeis: ${JSON.stringify(propIsAtFeis[0])} truthy: ${propIsAtFeis[0] === "true"} truthy2: ${isThisAFeis.value === 'true'}`)
        // }
        console.log(`IsThisAFeis: ${isThisAFeis.value}`);
      // }
    }

    onBeforeMount(function()
    {
      getFeisStatusAndLabels();
    });

    return {
      // eslint-disable-next-line vue/no-dupe-keys
      gradeFilterToApply,
      applyInactiveFilter,
      selectFilter,
      selectedRegion,
      isThisAFeis,
      bunLabel,
      tusLabel,
      meanLabel,
      openLabel
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../styles/palette";
@import "../styles/layout";

.music-img-background {
  background-color: blue;
}
.grade-filter {
  width: pxToRem(165px);
  height: pxToRem(100px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: $actions-cards-2;
  cursor: pointer;
  border-bottom: pxToRem(4.5px) solid grey;
  margin: pxToRem(20px) pxToRem(17px) pxToRem(15px) pxToRem(17px);
  border-bottom-left-radius: pxToRem(4px);
  border-bottom-right-radius: pxToRem(4px);

  p {
    margin: 0;
  }

  &.inactive {
    filter: grayscale(100%);
    opacity: 0.5;
  }

  &.primary-light-blue-2 {
    border-bottom: pxToRem(4.5px) solid $primary-light-blue-2;
  }

  &.primary-green-2 {
    border-bottom: pxToRem(4.5px) solid $primary-green-2;
  }

  &.primary-pink-2 {
    border-bottom: pxToRem(4.5px) solid $primary-pink-2;
  }

  &.primary-purple-2 {
    border-bottom: pxToRem(4.5px) solid $primary-purple-2;
  }

  &.primary-red-2 {
    border-bottom: pxToRem(4.5px) solid $primary-red-2;
  }

  &.primary-dark-green-2 {
    border-bottom: pxToRem(4.5px) solid $primary-dark-green-2;
  }

  &.primary-orange-2 {
    border-bottom: pxToRem(4.5px) solid $primary-orange-2;
  }

  p {
    color: $primary-dark-blue-2;
    font-size: pxToRem(16px);
  }
}

.music-img-bkg-small
{
  display: none;
}
#grade-filter-text {
  font-family: Apple Chancery, cursive;
  font-style: italic;
  text-align: center;
  color: $primary-purple-2;
}

@media only screen and (max-width: 780px) {
	.music-img-bkg-normal
	{
		display: none;
	}
  .music-img-bkg-small
  {
    display: block;
  }
  #grade-filter-text
  {
    font-size: 12px;
  }
  .grade-filter {
      width: pxToRem(100px);
      height: pxToRem(55px);
  }
}
@media only screen and (max-width: 320px) {
	.music-img-bkg-normal
	{
		display: none;
	}
  .music-img-bkg-small
  {
    display: block;
  }
  #grade-filter-text
  {
    font-size: 11px;
  }
  .grade-filter {
      width: pxToRem(70px);
      height: pxToRem(45px);
  }
}
</style>
